import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { DashboardEventT } from './type';

/**
 * Custom hook to fetch dashboard events.
 *
 * @param dashboardKey - The unique identifier for the dashboard.
 * @returns A UseQueryResult containing an array of dashboard events.
 */
export const useDashboardEventsQuery = (
    dashboardKey: number,
): UseQueryResult<DashboardEventT[]> =>
    useQuery({
        queryKey: ['dashboard_events', dashboardKey],

        queryFn: async () => {
            const response = await RQAPICallWithData<DashboardEventT[]>({
                endpoint: `explore/dashboard/${dashboardKey}/events`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
